/**
 * 转换 对象所有属性的首字母为大写
 * @param {Object} object
 * @returns
 */
export function convertInitialToUppercase(object) {
  if (!object) {
    return object
  }
  const str = JSON.stringify(object)
  const strs = str.replace(/"[a-z]\w+":/g, (match) => {
    return match.replace(match[1], match[1].toUpperCase())
  })
  return JSON.parse(strs)
}
